import type { Field, Form } from 'factorial-form'
import { TerminatePageTerminationTypeFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import { useCallback } from 'modules/core/hooks/useCallback'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

interface Props {
  form: Form
  country: string
  terminationTypes: TerminatePageTerminationTypeFragment[]
}

const TerminationTypeList = ({ form, country, terminationTypes }: Props) => {
  const countryTerminationTypes = useCallback(() => {
    let options = terminationTypes
      .filter((one) => one.country === country)
      .map((type) => {
        return {
          label: type.description,
          value: type.id,
          termination_reason_type: type.terminationReasonType,
          slug: type.slug,
        }
      })
      .sort((a, b) => a.label.localeCompare(b.label))

    if (country === 'es') {
      const otrasIndex = options.findIndex((element) => element.slug === 'otras_causas')
      if (otrasIndex > -1) {
        const removed = options.splice(otrasIndex, 1)
        options = options.concat(removed)
      }
    }
    return options
  }, [country])

  const options = countryTerminationTypes()

  const onSelectChange = (field: Field) => {
    const selected = options.find((x) => x.value == field.value)?.termination_reason_type
    form.setValues({
      termination_reason_type: selected,
      termination_type_id: Number(field.value),
    })
    return field
  }

  return (
    <Select
      mandatory={hasFeature('payroll_bundle')}
      options={options}
      field={form.get('termination_type_id')}
      label={i18n.t('employees.termination.termination_reason')}
      none={i18n.t('employees.termination.termination_empty')}
      onChange={() => onSelectChange(form.get('termination_type_id'))}
    />
  )
}

export default observer(TerminationTypeList)
